import type { KanbanAgent } from '@ts-tutor-kanban/interfaces'

import { useTutorKanbanStore } from '@stores/tutor-kanban'

import { useAdminRoutes } from '@composables/routes/admin-route.hook'

export const useAgentsApi = async (): Promise<KanbanAgent[]> => {
  const { $axios } = useNuxtApp()

  const url = useAdminRoutes('admin.agents')

  const tutorKanbanStore = useTutorKanbanStore()

  try {
    const { data } = await $axios.get(url!)
    const agents: KanbanAgent[] = data.data.agents

    tutorKanbanStore.setAgents(agents)

    return agents
  } catch (err: unknown) {
    console.error(err)

    return []
  }
}
